import { SettingPageAttendanceBalanceCarryoverFragment } from 'generated/resources/graphql'

import {
  isPastDate,
  isPastMonth,
  isPastWeek,
} from 'modules/attendance/components/ClockIn/TabsBreakdown/utils/dateUtils'

import { Cycle } from '../attendanceDateNavigatorContext'

class BalanceCarryoverUtils {
  static samePeriodCompensation({
    compensationPeriod,
    viewCycle,
    timeSheetDate,
  }: {
    balanceCarryover?: Pick<SettingPageAttendanceBalanceCarryoverFragment, 'resetFrequency'> | null
    compensationPeriod: string | undefined
    viewCycle: Cycle
    timeSheetDate: moment.Moment
  }): boolean {
    const pastMonth = isPastMonth(timeSheetDate)
    const pastWeek = isPastWeek(timeSheetDate)
    const pastDate = isPastDate(timeSheetDate)

    return (
      (compensationPeriod === 'daily' && pastDate) ||
      (compensationPeriod === 'monthly' && viewCycle === 'monthly' && pastMonth) ||
      (compensationPeriod === 'weekly' && viewCycle === 'weekly' && pastWeek)
    )
  }
}

export default BalanceCarryoverUtils
